import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  inject,
} from '@angular/core';
import {
  ControlValueAccessor,
  FormControl,
  FormsModule,
  NgControl,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIcon } from '@angular/material/icon';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-text-area-material',
  templateUrl: './text-area-material.component.html',
  styleUrls: ['./text-area-material.component.scss'],
  imports: [
    MatFormFieldModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIcon,
    CommonModule,
  ],
  providers: [],
})
export class TextAreaMaterialComponent
  implements ControlValueAccessor, OnInit, OnDestroy, OnChanges
{
  private readonly ngControl = inject(NgControl, {
    self: true,
    optional: true,
  });

  @Input() required = false;
  @Input() placeholder = '';
  @Input() width = '';
  @Input() disabled = false;
  @Input() errorInput = 'Error message';
  @Input() formControl: FormControl;
  @Input() label = '';

  @Output() valueChanged = new EventEmitter<any>();

  input = new FormControl('');

  constructor() {
    if (this.ngControl != null) {
      this.ngControl.valueAccessor = this;
    }
  }

  ngOnInit(): void {
    this.subscriptions.push(
      this.formControl.valueChanges.subscribe(value => {
        this.valueChanged.emit(value); // Emitir el valor cuando cambia
      })
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ('disabled' in changes) {
      const disabled = changes.disabled.currentValue;
      if (disabled) {
        this.formControl.disable();
      } else {
        this.formControl.enable();
      }
    }
  }

  onChange: any = () => {};
  onTouch: any = () => {};

  writeValue(input: string) {
    this.input.setValue(input);
  }
  subscriptions = [];
  registerOnChange(fn: any): void {
    this.subscriptions.push(this.input.valueChanges.subscribe(fn));
  }
  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  setDisabledState(disabled: boolean): void {
    disabled ? this.input.disable() : this.input.enable();
  }

  public get invalid() {
    return this.input.invalid && this.input.touched;
  }
}
